import { useEffect, useState } from "react";
import IMeetingOpenDTO from "../../../models/IMeetingOpenDTO";
import { authenticationService } from "../../../services/auth.service";
import { toast } from "react-toastify";
import toastOptions from "../../../utils/toastOptions";
import api from "../../../services/api";
import { Link } from "react-router-dom";
import { displayDateTime } from "../../../utils/masks";

export default function CheckInMeeting() {
  const [meetingOpened, setMeetingOpened] = useState<IMeetingOpenDTO>();
  const [hasMeetingOpen, setMeetingOpen] = useState<boolean | undefined>(undefined);
  const [isReadOnly, setReadOnly] = useState<boolean>();

  useEffect(() => {
    async function init() {
      try {
        setReadOnly(authenticationService.isReadOnly());
        
        const { data: dataMeeting } = await api.get("meetings/open");

        setMeetingOpened(dataMeeting.item);

        setMeetingOpen(
          !authenticationService.isAuxSec() &&
            dataMeeting.success &&
            dataMeeting.item?.meeting
            ? true
            : false
        );
      } catch (ex) {
        toast.warning("Problemas ao verificar em andamento", toastOptions);
      }
    }

    init();
  }, []);  

  return <>
    {hasMeetingOpen == undefined && (
        <div className="uk-card uk-card-body uk-card-success uk-flex uk-flex-middle uk-flex-center uk-card-hover">
          <div className="uk-inline-clip uk-transition-toggle">
            <div className="uk-transition-scale-up uk-transition-opaque">
              <div style={{ color: "#FFFFFF" }} uk-spinner="true; ratio:2">
                Carregando...
              </div>
            </div>
          </div>
        </div>
      )}
      {hasMeetingOpen == false && (
        <div className="uk-card uk-card-body uk-card-success uk-flex uk-flex-middle uk-flex-center uk-card-hover">
          <div className="uk-inline-clip uk-transition-toggle">
            {isReadOnly ? (
              <div className="uk-transition-scale-up uk-transition-opaque">
                <span>
                  <br />
                  Nenhuma Reunião em Andamento
                  <br />
                  <br />
                </span>
              </div>
            ) : (
              <Link to="/reuniao/nova" className="uk-button">
                <div className="uk-transition-scale-up uk-transition-opaque">
                  <span uk-icon="icon: plus; ratio: 2"></span>
                  <br />
                  Nova Reunião
                </div>
              </Link>
            )}
          </div>
        </div>
      )}
      {hasMeetingOpen && (
        <div className="uk-card uk-card-warning uk-card-small uk-card-hover">
          <div className="uk-card-header">
            <div className="uk-grid-small uk-flex-middle" uk-grid="true">
              <div className="uk-width-expand">
                <h3 className="uk-card-title uk-margin-remove-bottom">
                  Reunião em Andamento...
                </h3>
              </div>
            </div>
          </div>
          <div className="uk-card-body uk-margin-medium-top">
            <h3>
              <span uk-icon="icon: clock; ratio: 1.5"></span>
              <span className="uk-margin-left">
                Iniciada: {displayDateTime(meetingOpened?.meeting.createdDate)}
              </span>
            </h3>
            <h4>{meetingOpened?.qtyMembers} membro(s) presente(s)</h4>
          </div>
          {(authenticationService.canChange() ||
            authenticationService.isRoutine()) && (
            <div className="uk-card-footer">
              {!authenticationService.isRoutine() && (
                <Link to={`/reuniao/${meetingOpened?.meeting.id}`}>
                  Editar <span uk-icon="pencil"></span>
                </Link>
              )}
              <br />
              <Link to="/reuniao/em-andamento">
                Acessar <span uk-icon="arrow-right"></span>
              </Link>
            </div>
          )}
        </div>
      )}
  </>
}